
import {Component} from 'vue-property-decorator';
import AffiliateNetworkCreateForm from './create.vue';
import {Send} from '@/components/form-base';
import {pick} from 'lodash';
import reportUtils from '@/views/reports/report-utils';
import ApiServices from '@/services';

@Component
export default class EditAffNetDialog extends AffiliateNetworkCreateForm {
  child: boolean = true;
  reportUtils = reportUtils(this);

  async loadData() {
    this.edit = true;
    this.affiliate_network_id = this.data.id || this.$store.getters.selectedItem.id;
    this.$store.commit('loading', true);

    this.resetErrors();

    await this.affiliateNetworkApi.get(this.affiliate_network_id).then((data: any) => {
      this.form = pick(data, [
        'name',
        'tags',
        'status',
        'acceptDoublePostbacks',
        'appendClickId',
        'clickIdParam',
        'postbackOnlyWhiteIps',
        'hasCustomParamMasking',
        'postbackStatusChargeback',
        'postbackStatusConfirm',
        'postbackStatusDecline',
        'postbackStatusDefault',
        'postbackStatusNew',
        'postbackWhiteIps',
        'usePostbackStatuses',
        'workspaceId',
        'created',
        'updated',
        'updatedBy',
      ]);

      if(data.templateId && data.affiliateNetworkTemplate) {
        this.form.templateId = data.templateId;
        this.form.clickIdPlaceholder = data.affiliateNetworkTemplate.clickIdPlaceholder || this.defaultAffiliateNetworkTemplate.clickIdPlaceholder;
        this.form.payoutPlaceholder = data.affiliateNetworkTemplate.payoutPlaceholder || this.defaultAffiliateNetworkTemplate.payoutPlaceholder;
        this.form.transactionIdPlaceholder = data.affiliateNetworkTemplate.transactionIdPlaceholder || this.defaultAffiliateNetworkTemplate.transactionIdPlaceholder;
        this.form.statusPlaceholder = data.affiliateNetworkTemplate.statusPlaceholder || this.defaultAffiliateNetworkTemplate.statusPlaceholder;
      } else {
        Object.assign(this.form, this.defaultAffiliateNetworkTemplate);
      }
      
      return data;
    });

    this.oldHash = this.getCurrentHash();
    this.show = true;
    this.$store.commit('loading', false);
  }

  get modalTitle(){
    return this.t('Edit affiliate network')
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);

    return this.affiliateNetworkApi.putUpdate(this.affiliate_network_id, this.processForm(this.form))
      .then(async (data) => {
        await ApiServices.getUserProfile();
        const { id } = data;

        this.oldHash = this.getCurrentHash();

        this.reportUtils.updateName('affiliate-networks', id);

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Affiliate Network has been changed'));

        const {name,usePostbackStatuses, hasCustomParamMasking, acceptDoublePostbacks, postbackOnlyWhiteIps, postbackWhiteIps} = this.form;
        this.$mixpanel?.track('affiliate_network_edit', {
          name,
          'use_postback_statuses': !!usePostbackStatuses,
          'accept_double_postbacks': !!acceptDoublePostbacks,
          'postback_only_white_ips_enabled': !!postbackOnlyWhiteIps,
          'has_custom_param_masking': !!hasCustomParamMasking,
          ...(this.form.postbackOnlyWhiteIps && {'postback_white_ips': postbackWhiteIps}),
        });
        this.close();
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }
}
